<template>
	<component :is="props.tag" class="rmp-text" :class="`rmp-text--${textToken}`"
			   :style="{ color, fontWeight: textWeight, fontFamily: textFont }" v-on="$listeners">
		<slot></slot>
	</component>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { RmpTextTag, RmpTextType, RmpTextSize, RmpTextBaseToken, RmpTextFont } from "@rmp/core/components/typography/types";

interface Props {
	tag?: RmpTextTag;
	font?: RmpTextFont;
	type?: RmpTextType;
	size?: RmpTextSize;
	color?: string;
	weight?: number | string;
}

const props = withDefaults(defineProps<Props>(), {
	tag: "p",
	type: "body",
	size: "medium",
	color: undefined,
	weight: undefined,
	font: undefined,
});

const textToken = computed<RmpTextBaseToken>(() => {
	const { type, size } = props;
	if (type === "caption" && size === "small") return "caption-small";
	return type === "display" || type === "title" || type === "body"
		? `${type}-${size}`
		: type.replace(/-(regular|bold)$/, "") as RmpTextBaseToken;
});

const textFont = computed(() => props.font ? `var(--rmp-font-${props.font})` : undefined);

const textWeight = computed(() => {
	if(props.weight !== undefined) return props.weight;
	if(props.type.endsWith("-bold")) return 700;
	if(props.type.endsWith("-regular")) return 400;
	return undefined;
});
</script>
